module.exports = __webpack_public_path__ + "img/meeting_5.12cfb469.jpg";